import React, { useState } from 'react';
import dayjs from 'dayjs';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import {
    BranchApprovalStatusEnum,
    BranchStatusEnum,
    ModuleEnum,
    PermissionsEnum,
    TransactionStatusEnum,
} from '~utils/enums';

import { TUpdateBranchesStatusReduxParams } from '~types/feat/approval';

import Table from '~components/molecules/Table';
import ActionButton from '~components/atoms/ActionButton';

import UtilFunctions from '~utils/functions';
import * as Styles from './_branchesApprovalTable.module.scss';

const BranchesApprovalTable = () => {
    const dispatch = useAppDispatch();

    const {
        Misc: {
            renderApprovalStatusChip,
        },
    } = UtilFunctions;

    const regionList = useAppSelector(state => state.branch.allRegions);
    const pendingBranchesListing = useAppSelector(state => state.approval.pendingBranchesListing.data);
    const getPendingsBranchesListingIsLoading = useAppSelector(state => state.approval.loadings.getPendingBranchesListing);
    const access = useAppSelector(state => state.auth.userDetails.access);

    const hasEditAccess = access.find(item => item.permission === PermissionsEnum.Edit)?.modules.find(module => module === ModuleEnum.Approval);

    const setTempUpdateTransactionState = (data: TUpdateBranchesStatusReduxParams) => dispatch(combinedActions.approvalSetTempUpdateBranchesState(data));
    const setConfirmUpdateStatusModalIsOpen = (open: boolean) => dispatch(combinedActions.approvalSetConfirmUpdateBranchesStatusModalIsOpen(open));

    const handleApproveClick = (data: TUpdateBranchesStatusReduxParams) => {
        setConfirmUpdateStatusModalIsOpen(true);
        setTempUpdateTransactionState(data);
    };

    const handleRejectClick = (data: TUpdateBranchesStatusReduxParams) => {
        setConfirmUpdateStatusModalIsOpen(true);
        setTempUpdateTransactionState(data);
    };

    const tableHeader = [
        'BRANCH CODE',
        'BRANCH NAME',
        'REGION NAME',
        'STATUS',
        'CREATED AT',
        'ACTION',
    ];

    const tableBody = pendingBranchesListing.map(transaction => {
        const {
            id,
            branchCode,
            branchName,
            regionId,
            status,
            createdAt,

        } = transaction;

        const renderRegionName = () => {
            const regionName = regionList.find(region => region.regionId === regionId)?.regionName;

            if (regionName) return regionName;

            return '-';
        };

        return [
            branchCode,
            branchName,
            renderRegionName(),
            renderApprovalStatusChip(status, BranchApprovalStatusEnum[status]),
            dayjs(createdAt).format('DD/MM/YYYY hh:mm A'),
            (
                <div
                    key={id}
                    className={Styles['action-button-container']}
                >
                    {hasEditAccess
                        && (
                            <ActionButton
                                label='Approve'
                                onClick={() => handleApproveClick({ id: id, status: BranchApprovalStatusEnum.Approved })}
                                className={`${Styles['action-button']} ${Styles.approve}`}
                            />
                        )
                    }

                    {hasEditAccess
                        && (
                            <ActionButton
                                label='Reject'
                                onClick={() => handleRejectClick({ id: id, status: BranchApprovalStatusEnum.Rejected })}
                                className={`${Styles['action-button']} ${Styles.reject}`}
                            />
                        )
                    }
                </div>
            ),
        ];
    });

    return (
        <>
            <Table
                header={tableHeader}
                body={tableBody}
                isLoading={getPendingsBranchesListingIsLoading}
            />
        </>
    );
};

export default BranchesApprovalTable;
